<template>
  <div class="highlight-wrap" :class="filterType">
    <div class="top-section-wrap" @click="topSectionClicked">
      <div class="top-section-text">
        <div class="field-name-wrap">
          {{ filedName }}
        </div>
        <div class="sub-title-wrap">
          {{ subField }}
        </div>
      </div>
      <div class="arrow-wrap">
        <div :class="[expandCheckbox ? 'arrow-up' : 'arrow-down']"></div>
      </div>
    </div>
    <div class="checkbox-wrap" v-show="expandCheckbox">
      <slot></slot>
    </div>
  </div>
</template>
<script>
export default {
  props: {
    filterType: {
      type: String,
      required: true,
    },
    districtCount: {
      type: Number,
      default: 0,
    },
    sbuField: {
      type: String,
      default: '',
    },
    agentCount: {
      type: Number,
      default: 0,
    },
  },
  data() {
    return {
      expandCheckbox: false,
    };
  },
  computed: {
    filedName() {
      switch (this.filterType) {
        case 'highlight':
          return this.$t('find.HIGHLIGHT');
        case 'district':
          return this.$t('find.DISTRICT');
        case 'agent':
          return this.$t('find.AGENT');
      }
    },
    subField() {
      switch (this.filterType) {
        case 'highlight':
          return this.sbuField;
        case 'district':
          if (this.districtCount)
            return this.$tc('find.DISTRICT_CHOSEN', this.districtCount, { n: this.districtCount });
          return this.$t('find.ALL');
        case 'agent':
          return this.agentCount > 0
            ? `${this.$t('main.SELECTED_FILTER')} (${this.agentCount})`
            : this.$t('find.ALL');
      }
    },
  },
  methods: {
    topSectionClicked() {
      this.expandCheckbox = !this.expandCheckbox;
    },
  },
};
</script>
<style scoped>
.highlight-wrap {
  border: 1px solid #e5e5e5;
  border-radius: 4px;
  background: #ffffff;
  background-repeat: no-repeat;
  background-position: 15px 19px;
}

.highlight-wrap.highlight,
.highlight-wrap.agent {
  background-image: url('data:image/svg+xml;utf-8,<svg width="20" height="20" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg"><path d="M14.9193 17.5H5.66927V6.83337L11.4609 0.833374L12.2734 1.47921C12.3568 1.54865 12.4193 1.64587 12.4609 1.77087C12.5026 1.89587 12.5234 2.04865 12.5234 2.22921V2.43754L11.5859 6.83337H17.8151C18.1484 6.83337 18.4401 6.95837 18.6901 7.20837C18.9401 7.45837 19.0651 7.75004 19.0651 8.08337V9.79171C19.0651 9.88893 19.0755 9.98962 19.0964 10.0938C19.1172 10.198 19.1068 10.2987 19.0651 10.3959L16.4401 16.4375C16.3151 16.7292 16.1102 16.9792 15.8255 17.1875C15.5408 17.3959 15.2387 17.5 14.9193 17.5ZM6.91927 16.25H15.1901L17.8151 10.0209V8.08337H10.0443L11.1484 2.89587L6.91927 7.35421V16.25ZM5.66927 6.83337V8.08337H2.89844V16.25H5.66927V17.5H1.64844V6.83337H5.66927Z" fill="%23252525"/></svg>');
}
.highlight-wrap.district {
  background-image: url('data:image/svg+xml;utf-8,<svg width="20" height="20" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg"><path d="M9.99479 9.79175C10.3976 9.79175 10.7413 9.64939 11.026 9.36466C11.3108 9.07994 11.4531 8.73619 11.4531 8.33341C11.4531 7.93064 11.3108 7.58689 11.026 7.30216C10.7413 7.01744 10.3976 6.87508 9.99479 6.87508C9.59201 6.87508 9.24826 7.01744 8.96354 7.30216C8.67882 7.58689 8.53646 7.93064 8.53646 8.33341C8.53646 8.73619 8.67882 9.07994 8.96354 9.36466C9.24826 9.64939 9.59201 9.79175 9.99479 9.79175ZM9.99479 16.6876C11.842 15.007 13.2066 13.4827 14.0885 12.1147C14.9705 10.7466 15.4115 9.54175 15.4115 8.50008C15.4115 6.86119 14.8872 5.52091 13.8385 4.47925C12.7899 3.43758 11.5087 2.91675 9.99479 2.91675C8.4809 2.91675 7.19965 3.43758 6.15104 4.47925C5.10243 5.52091 4.57812 6.86119 4.57812 8.50008C4.57812 9.54175 5.02951 10.7466 5.93229 12.1147C6.83507 13.4827 8.18924 15.007 9.99479 16.6876ZM9.99479 18.3334C7.75868 16.4306 6.08854 14.6633 4.98438 13.0313C3.88021 11.3994 3.32812 9.88897 3.32812 8.50008C3.32812 6.41675 3.99826 4.75703 5.33854 3.52091C6.67882 2.2848 8.2309 1.66675 9.99479 1.66675C11.7587 1.66675 13.3108 2.2848 14.651 3.52091C15.9913 4.75703 16.6615 6.41675 16.6615 8.50008C16.6615 9.88897 16.1094 11.3994 15.0052 13.0313C13.901 14.6633 12.2309 16.4306 9.99479 18.3334Z" fill="%23252525"/></svg>');
}

.top-section-wrap {
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding: 7px 15px 7px 43px;
  cursor: pointer;
  gap: 8px;
}

.sub-title-wrap {
  color: #9a9a9a;
  font-size: 16px;
}

.arrow-up {
  width: 0;
  height: 0;
  border-right: 3px solid transparent;
  border-bottom: 5px solid #252525;
  border-left: 3px solid transparent;
  margin-left: 6px;
}

.arrow-down {
  width: 0;
  height: 0;
  border-right: 3px solid transparent;
  border-top: 5px solid #252525;
  border-left: 3px solid transparent;
}

.top-section-text {
  display: flex;
  gap: 4px;
  flex-direction: column;
}

.arrow-wrap {
  width: 20px;
  height: 20px;
  flex-shrink: 0;
  display: flex;
  align-items: center;
  justify-content: center;
}
.checkbox-wrap >>> .more-options-wrap {
  background: white;
  height: auto;
}

.checkbox-wrap >>> .more-options-container {
  height: auto;
  width: auto;
  flex-direction: row;
  overflow-y: auto;
  gap: 26px 8px;
}

.checkbox-wrap >>> .more-options-container > div {
  flex: 1 calc(100% / 2 - 24px);
}

.checkbox-wrap {
  border-top: 1px solid #e5e5e5;
}

.checkbox-wrap >>> .regions-container {
  flex-basis: fit-content;
}

.checkbox-wrap >>> .region-tab-container {
  min-width: 76px;
  margin: auto 16px;
}

.checkbox-wrap >>> .districts-wrap {
  height: 410px;
  flex-direction: row;
  flex-wrap: wrap;
}

.checkbox-wrap >>> .atomic-district {
  flex-basis: calc(50% - 16px);
}
</style>
